import { type InputCreateConnectionRequest } from "../../../gql-generated/types";
import { LensCompoundIdOperations } from "../../lenses/models";

import { Connection } from "./Connection";
import { RangeModifierOperations } from "./RangeModifierOperations";
import { emptyCompoundId } from "./emptyCompoundId";

export class GroupConnection extends Connection {
    readonly lensCompoundId = emptyCompoundId;
}

export const GroupConnectionOperations = {
    toVariables(
        organizationId: string,
        groupId: string,
        { priority, scheduleRange, vendorData, lensCompoundId }: GroupConnection,
    ): InputCreateConnectionRequest {
        return {
            lensCompoundId: LensCompoundIdOperations.toVariables(lensCompoundId),
            groupId,
            organizationId,
            priority,
            schedule: RangeModifierOperations.toSchedule(scheduleRange),
            vendorData: vendorData.map(({ key, value }) => ({
                key,
                value,
            })),
        };
    },
};
